import { css } from "lit";

/**
 * The style fragments every DOM control shares: the button colour transition as CSS filters
 * (hover #ccc, pressed #727272, disabled #474747 over white), icon boxes painted from the atlas
 * (`.art` = the frame as an image, `.mask` = the frame as a mask over `background-color`).
 */
export const chromeControlStyles = css`
  button { margin: 0; padding: 0; border: 0; background: transparent; font: inherit; color: inherit; cursor: pointer; touch-action: manipulation; -webkit-tap-highlight-color: transparent; }
  button[disabled] { cursor: default; }
  .art { background: transparent no-repeat center / 100% 100%; }
  .mask { -webkit-mask: no-repeat center / 100% 100%; mask: no-repeat center / 100% 100%; }
  .bar-button:hover { filter: brightness(0.8); }
  .bar-button:active { filter: brightness(0.45); }
  .bar-button[disabled], .bar-button[disabled]:hover { filter: brightness(0.28); }
  [data-fit] { display: inline-block; max-width: none; transform-origin: center; white-space: nowrap; }
  .shadow { text-shadow: 0 0 10px #000; }
  .outline { -webkit-text-stroke: 1px #000; paint-order: stroke fill; }
`;
